/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  requestApproveManyTum,
  requestApproveTum,
  requestGetCountStatusNewTumRegisterList,
  requestGetNewTumRegisterList,
  requestNewTumRegister,
} from 'app/api/newTumRegister'
import {
  INewTumRegister,
  IParamsGetNewTumRegister,
  IPayloadApproveTum,
  IPayloadReviewNewTumRegister,
  IResponseNewTumRegisterList,
  IResponseTotalStatus,
} from 'app/api/newTumRegister/model'
import { getToken } from 'app/service/storage/storage-service'
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query'
import { IResponseQueryList } from '../model/common'
import { NewTumRegisterKeys } from '../query-key/newTumRegister'
import { ResponseType } from 'parkway-web-common'

export function useGetNewTumRegister(
  params: IParamsGetNewTumRegister,
  enabled = true,
) {
  const token = getToken()
  return useInfiniteQuery<IResponseQueryList<INewTumRegister[]>, undefined>(
    NewTumRegisterKeys.listNewTumRegister(params),
    async () => {
      try {
        const res: IResponseNewTumRegisterList =
          await requestGetNewTumRegisterList(params)
        const data: INewTumRegister[] = res?.data?.rows || []
        return {
          data,
          total: res?.data?.total ?? 0,
        }
      } catch (error: any) {
        return {
          data: [],
          total: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export function useGetNewTumRegisterTotalStatus(
  params?: { userId?: number },
  enabled = true,
) {
  const token = getToken()
  return useQuery<IResponseTotalStatus, undefined>(
    NewTumRegisterKeys.countStatusNewTumRegister(params),
    async () => {
      try {
        const res: ResponseType<IResponseTotalStatus> =
          await requestGetCountStatusNewTumRegisterList(params)

        const data: IResponseTotalStatus = res?.data as IResponseTotalStatus
        return data
      } catch (error: any) {
        return {
          ACCEPTED: 0,
          REJECTED: 0,
          WAITING: 0,
          CANCELED: 0,
        }
      }
    },
    {
      enabled: !!token && enabled,
    },
  )
}

export const useReviewTum = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadReviewNewTumRegister, unknown>(
    async (body: IPayloadReviewNewTumRegister) => {
      return await requestNewTumRegister(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: NewTumRegisterKeys.allNewTumRegister,
        })
      },
    },
  )
}
export const useApproveTum = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadApproveTum, unknown>(
    async (body: IPayloadApproveTum) => {
      await requestApproveTum(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: NewTumRegisterKeys.allNewTumRegister,
        })
      },
    },
  )
}

export const useApproveManyTum = () => {
  const query = useQueryClient()
  return useMutation<unknown, unknown, IPayloadApproveTum[], unknown>(
    async (body: IPayloadApproveTum[]) => {
      await requestApproveManyTum(body)
    },
    {
      onSuccess: () => {
        query.invalidateQueries({
          queryKey: NewTumRegisterKeys.allNewTumRegister,
        })
      },
    },
  )
}
